import React from "react";

import Dialog_ from "root/entities/Dialog";

export default function (props) {
  return <Dialog_ {...props} />;
}
